import React, { useEffect, useRef } from 'react';
import { useRealtime } from '../../contexts/RealtimeContext';
import { generateWatermarkData, addVisibleWatermark, addWatermarkMetadata } from '../../utils/questionWatermark';
import KatexRenderer from '../KatexRenderer';

/**
 * Watermarked Question Component
 * Wraps questions with visible and invisible watermarks
 */
const WatermarkedQuestion = ({ 
  question, 
  questionIndex, 
  testId, 
  sessionId,
  testInfo 
}) => {
  const containerRef = useRef(null);
  const { currentUser } = useRealtime();

  useEffect(() => {
    if (!containerRef.current || !currentUser || !question) return;

    // Generate watermark data
    const watermarkData = generateWatermarkData(
      currentUser.uid,
      testId,
      question.id || `q-${questionIndex}`,
      sessionId || `session-${Date.now()}`
    );

    // Add visible watermark
    addVisibleWatermark(containerRef.current, watermarkData, testInfo);

    // Add watermark metadata
    addWatermarkMetadata(containerRef.current, watermarkData);

  }, [question, questionIndex, testId, sessionId, testInfo, currentUser]);

  if (!question) return null;

  return (
    <div 
      ref={containerRef}
      className="question-container relative"
      style={{ position: 'relative', minHeight: '50px', width: '100%' }}
    >
      {/* Question content - watermark will be applied to this container */}
      <div className="question-content w-full">
        <KatexRenderer content={question.question} />
      </div>
    </div>
  );
};

export default WatermarkedQuestion;

